module.exports = __webpack_public_path__ + "img/scene4@2x.27377a51.png";